import { mergeAttributes, Node } from '@tiptap/core';

import { BACKSPACE_KEYS, FORM_FIELD_LINE_CLASS_NAME, FORM_FIELD_LINE_NODE_NAME } from './constants';
import placeCaretBelow from '../../utils/placeCaretBelow';
import { getFormFieldExitPos } from './formFieldHelpers';

/** The line an Inline text or Dropdown field sits on in a card: that field only, no text of its own. */
const FormFieldLineNode = Node.create({
  name: FORM_FIELD_LINE_NODE_NAME,
  // The card's content expression names the line by this group.
  group: 'formFieldLine',
  content: 'inlineTemplateField?',

  parseHTML() {
    return [{ tag: `div.${FORM_FIELD_LINE_CLASS_NAME}` }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { class: FORM_FIELD_LINE_CLASS_NAME }), 0];
  },

  addKeyboardShortcuts() {
    // Nothing before the field can be deleted; Tiptap's Backspace would end in a no-op step or the browser's delete.
    const keepLineStart = () => {
      const { empty, $from } = this.editor.state.selection;
      return empty && $from.parent.type === this.type && $from.parentOffset === 0;
    };

    // Beside the field or on a selected Dropdown, Enter leaves the card.
    const exitCard = () => {
      const { state, view } = this.editor;
      const { $from } = state.selection;
      const exitPos = $from.parent.type === this.type ? getFormFieldExitPos($from) : undefined;
      if (exitPos === undefined) return false;
      view.dispatch(placeCaretBelow(state.tr, exitPos));
      return true;
    };

    return { ...Object.fromEntries(BACKSPACE_KEYS.map((key) => [key, keepLineStart])), Enter: exitCard };
  },
});

export default FormFieldLineNode;
